import { render, staticRenderFns } from "./ChangeSelection.vue?vue&type=template&id=6d270e60&scoped=true"
import script from "./ChangeSelection.vue?vue&type=script&lang=js"
export * from "./ChangeSelection.vue?vue&type=script&lang=js"
import style0 from "./ChangeSelection.vue?vue&type=style&index=0&id=6d270e60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d270e60",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {EducationStreamListTheList: require('/builds/gb-developers/geekbrains-client/components/pages/education/StreamList/TheList.vue').default})
